import React from "react"
import Cookies from 'js-cookie' //https://www.npmjs.com/package/js-cookie
import Breadcrumb from '../components/breadcrumb';
import $ from 'jquery/dist/jquery'

export default class ZipFinder extends React.Component 
{
    constructor(props) 
    {
        super(props);

        this.state = {
            zip: ''
        }            

        if(this.props.state !== undefined)
        {
            this.place =
            {
                name:undefined,
                state:
                {
                    name:this.props.state.name,
                    av:this.props.state.av
                }    
            }
        }    

        this.code = this.props.code;  
        this.codes = this.props.codes;      
        this.service = this.props.env.service !== undefined ? this.props.env.service : 'https://bookable-api-dev.azurewebsites.net';
        this.site = this.props.env.site !== undefined ? this.props.env.site : 'dumpster'; 
        this.type = this.props.type; 
        this.env = this.props.env;
        this.finderopenmodal = this.props.finderopenmodal;          
         
        this.pickBg();        
        this.mainDivClasses();
    }

    addBreadcrumb= () =>
    {
        if(this.props.state !== undefined)
        {
           return (
                <Breadcrumb 
                    code={this.code} 
                    place={this.place} 
                    codes={this.codes}
                    url={this.props.url}/>
           )
        }
    }

    mainDivClasses = () =>
    {
        this.mainclasses = 'zip-finder '+this.env.site;

        if(this.props.class !== undefined)
        {
            this.mainclasses += ' '+ this.props.class
        }        
    }

    pickBg = () =>
    {
        let bg = this.code+'-single.jpg';
        const state = this.props.state;
        
        this.requestImageFile = require.context('../images/backgrounds', true, /.jpg$/);            
        
        if(state === undefined)
        {
            bg = bg.replace('-single', '');
        }   
        
        if(bg === 'home.jpg')
        {
            bg = 'home-'+this.env.site+'.jpg';
        }

        this.background = bg;
    }

    pickTitle = () =>
    {       
        if (this.props.title !== undefined)
        {
            return this.props.title;
        }        
        
        let title = this.env.site ==='dumpster' ? "Find {state} {code}" : "Find {state} {code} Contractors";
        let replace = '';

        const state = this.props.state;
        const codes = this.props.codes;

        codes.map(code =>
        {
            if(this.code === code.code)   
            {
                let name = code.name === 'Demolition Contractors' ? 'Demolition' : code.name;
                title = title.replace('{code}', name);
            }
            
            return true;
        })
        
        if(state !== undefined)
        {
            replace = state.name;   
        }

        title = title.replace('{state}', replace);

        return title;
    }

    pickText = () =>
    {
        if (this.props.text !== undefined)
        {
            return this.props.text;
        }   

        let text = this.env.site === 'dumpster' ? "We’ll introduce you to top {code} providers in your area" : "We'll introduce you to professional {code} contractors ready to complete your project";

        const codes = this.props.codes;

        codes.map(code =>
        {
            if(this.code === code.code)   
            {
                let small = code.name.toLowerCase();
                text = text.replace('{code}', small);
            }
            
            return true;
        })

        return text;        
    }

    handleSubmit = event =>  
    {
        event.preventDefault();
        
        const zip = this.state.zip;

        if(!this.validateValue(zip))
        {
            this.showError('Zip Code is required');
            return;
        }
        
        if(!this.validateNumber(zip))
        {
            this.showError('The zip code must have 5 number');
            return;
        }   

        this.getUrl(zip,true);
    }

    handleInputChange = event => 
    {
        const target = event.target
        const value = target.value
        const name = target.name

        this.setState({
            [name]: value,
        })
    }

    validateValue = value =>
    {
        return value !== '' ? true : false;     
    }

    validateNumber = value =>
    {
        const regex = new RegExp('^\\d{5}$');
        return regex.test(value);       
    }

    getUrl = (zip, redirect) =>
    {
        let endpoint = '';

        let code = this.code;

        switch(this.site)
        {
            case 'dumpster':
                code = code === 'home' ? 'dumpster' : code;
                endpoint = '/api/v1/kpp/service_types/'+code+'/zip_codes/'+zip;                
                break;

            case 'demolition':
                code = code === 'home' ? 'demolition-contractors' : code;
                endpoint =  '/api/v1/kpp/keywords/'+code+'/zip_codes/'+zip;
                break;
            
            default:
                break;
        }
        
        if(endpoint !== '')
        {
            const url = this.service+endpoint;
            
            fetch(url,
            {
                method: 'get',                
            })
            .then((response) => 
            {                               
                if(response.status === 400)
                {
                    return '/redirect/no-zip-found';
                }
            
                return response.json();
            })
            .then((response) => 
            { 
                this.cookies(zip); 
                
                this.setState({'redirect': response});

                if(redirect)
                {                    
                    if(this.finderopenmodal)
                    {
                        $('#quote-steps-modal').modal('show');
                        return;
                    }                   
                   
                    this.redirect(response);
                }         
            })
            .catch((error) => 
            {              
                console.log(error);
            })
        }
    }

    cookies = (zip) =>
    {        
        Cookies.set('zipcode', zip);
    }

    showError = text =>
    {
        const input = document.getElementById(this.props.id); 
        
        input.value = '';
        input.placeholder = text;
    }

    redirect = url =>
    {           
        if(typeof url !== 'object' &&  !Array.isArray(url))  
        {
            window.location.replace('/'+url);
        }      
    }

    zipTop = () =>
    {
        this.requestIconFile = require.context('../images/icons', true, /.png$/);
        
        if(this.env.site === 'dumpster')
        {
            return <></>
        }
        
        return(
            <ul class="ziptop">
                <li><img src={this.requestIconFile('./tell-us-about-your-project-icon-1.png')} alt=""/> Tell us about your project</li>
                <li><img src={this.requestIconFile('./get-connected-to-demo-pros-icon-2.png')} alt=""/> Get connected with matched pros</li>
                <li><img src={this.requestIconFile('./get-free-quotes-easily-icon-3.png')} alt=""/> Compare free quotes easily</li>
            </ul>
        )
    }

    getFinder = type =>
    {
        switch (type) 
        {
            case 'small':
                return(
            
                    <div className="zip-finder-small mb-5">
                        <h3>{this.props.title}</h3>
                        <div className="card">
                            <form onSubmit={this.handleSubmit}>
                                
                                {this.zipTop()}
        
                                <input
                                    id={this.props.id}
                                    className="form-control"
                                    type="text"
                                    name="zip"
                                    value={this.state.zip}
                                    placeholder="Enter Zip Code"
                                    onChange={this.handleInputChange}
                                    maxLength="5"
                                    />
        
                                <input className="btn btn-primary" type="submit" value={this.props.button}/>
                            </form>
                        </div>                
                    </div>
                    
                )                
        
            default:
                return(
                    <div className={this.mainclasses}>
                        <div className="container-fluid">

                            {this.addBreadcrumb()}

                            <section className="row">
                                <div className="header-image header-image-home col-12" style={ {backgroundImage: `url(${this.requestImageFile(`./${this.background}`)})`} }>
                                    <div className="row justify-content-center align-items-center h-100">
                                        <div className="col-md-12 col-lg-8 hero-title text-center">                                                                    

                                            <h1>{this.pickTitle()}</h1>
                                            <h3>{this.pickText()}</h3>                                   

                                            <form className="row justify-content-center" onSubmit={this.handleSubmit}>
                                                <div className="col-md-12 col-lg-8 col-lg-offset-2 search">
                                                    <div className="input-group" id="searcher">
                                        
                                                        <input
                                                            id={this.props.id}
                                                            className="form-control"
                                                            type="search"
                                                            name="zip"
                                                            value={this.state.zip}
                                                            placeholder="Enter Zip Code"
                                                            onChange={this.handleInputChange}
                                                            maxLength='5'
                                                            />

                                                        <button 
                                                            type="submit" 
                                                            id="getStarted" 
                                                            className="btn btn-primary btn-sm">{this.props.button}</button>

                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className="row title">
                                <div className="col-12">
                                    <h3 className="justify-content-center text-white">{this.props.bottomtext}</h3>
                                </div>
                            </section>
                        </div>
                    </div>
                
                )                
        }
    }

    render() 
    {
        return (
            this.getFinder(this.type)
        )
    }
}